<template>
	<Tooltip
		textAlign_prop="left"
		textPosition_prop="bottom-right"
		maxWidth_prop="max-w-100 text-xs"
		iconHeight_prop="0.75rem"
		iconWidth_prop="0.75rem"
		:iconColor_prop="colorGrey8"
		tooltipClass_prop="p-5"
	>
		<MarkdownRenderer :content="$store.state.glossaries.totalPayment.body" />
	</Tooltip>
</template>

<script>
	import MarkdownRenderer from "../MarkdownRenderer.vue"
	import Tooltip from "../Tooltip.vue"

	export default {
		name: "TooltipEstimateMaximumPayment",
		components: {
			Tooltip,
			MarkdownRenderer,
		},

		data() {
			return {
				colorGrey8: getComputedStyle(document.documentElement).getPropertyValue(
					"--color-grey8",
				),
			}
		},

		created() {
			if (!this.$store.state.glossaries.totalPayment.body) {
				this.$store.dispatch("glossaries/setTotalPayment")
			}
		},
	}
</script>
